import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description FrancExchange icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { FrancExchange } from '@sravni/design-system-icons'
 *
 * <FrancExchange />
 * ```
 */
var FrancExchange = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "FrancExchange", viewBox: "0 0 20 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#FrancExchange__a)", stroke: "currentColor" },
        React.createElement("path", { d: "M9.626 1.047a7.223 7.223 0 0 0-4.112 1.62l-.347-.36A7.722 7.722 0 0 1 9.627.545v.502Zm1-.502C14.39.781 17.41 3.65 17.668 7.25h-.501c-.257-3.31-3.045-5.97-6.54-6.204v-.5Zm6.54 7.705h.501a6.977 6.977 0 0 1-.078.633l-.463-.111.03-.122h-.036c.02-.133.035-.266.046-.4ZM10.806 14.953a7.223 7.223 0 0 0 4.112-1.621l.352.364a7.751 7.751 0 0 1-4.464 1.758v-.501Zm-1 0v.501c-3.763-.235-6.785-3.097-7.042-6.704h.501c.257 3.31 3.046 5.97 6.541 6.203ZM3.266 7.75h-.5c.016-.215.042-.426.077-.634l.466.112-.033.132h.035c-.019.129-.034.259-.044.39ZM1.857 7.273l-.353-.353.433-.433.176.176.176.177-.432.433Zm2.632-.353-.352.353-.433-.433.176-.177.177-.176.432.433ZM18.924 8.975l-.428.428-.176-.177-.177-.176.428-.428.353.353Zm-2.628-.358.433.433-.176.176-.177.177-.433-.433.353-.353Z", fill: "currentColor" }),
        React.createElement("path", { d: "M12.476 4.37h-3.64v7.65M12.476 7.75h-3.64", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M11.046 10.12h-3.26", strokeWidth: "1.3", strokeLinecap: "round", strokeLinejoin: "round" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "FrancExchange__a" },
            React.createElement("path", { fill: "currentColor", transform: "translate(.576 .03)", d: "M0 0h19.28v15.94H0z" }))))); });

export { FrancExchange };
//# sourceMappingURL=FrancExchange.js.map
